export default "__VITE_ASSET__C$npvJqr__"